document.addEventListener('DOMContentLoaded', function() {
  initVariantSelection();
  initAjaxCart();
  initAccordions();
  initCartDrawerEvents();
  initSoundEffects();
  initImageProtection();
  initPixelEvents();
});

/* Meta Pixel action events.
   Page-load events (PageView, ViewContent, Search) fire from theme.liquid,
   where the Liquid objects are available. These two are user actions. */
function trackPixelEvent(event, params) {
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', event, params);
}

function initPixelEvents() {
  // Both the cart page and the cart drawer submit through button[name="checkout"].
  document.addEventListener('click', function(e) {
    if (!e.target.closest('button[name="checkout"]')) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        trackPixelEvent('InitiateCheckout', {
          content_type: 'product',
          content_ids: cart.items.map(item => String(item.id)),
          contents: cart.items.map(item => ({
            id: String(item.id),
            quantity: item.quantity
          })),
          num_items: cart.item_count,
          value: cart.total_price / 100,
          currency: (window.themeSettings || {}).currency
        });
      })
      .catch(() => {
        // Never let a tracking failure interfere with reaching checkout.
      });
  }, { passive: true });
}

/* Sizing dropdown & variant matching */
function initVariantSelection() {
  document.querySelectorAll('.PI__select').forEach(select => {
    const placeholderText = select.parentNode.querySelector('.PI__placeholder-text');
    
    // Set initial text
    if (placeholderText && select.options.length > 0) {
      placeholderText.textContent = select.options[select.selectedIndex].text;
    }

    select.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      
      // Update custom overlay text
      if (placeholderText) {
        placeholderText.textContent = selectedOption.text;
      }

      // Check variant availability
      const form = this.closest('form');
      const submitBtn = form.querySelector('.add-to-cart-submit-btn');
      if (submitBtn) {
        const isAvailable = selectedOption.getAttribute('data-available') === 'true';
        if (isAvailable) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = 'ADD TO CART';
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.textContent = 'SOLD OUT';
        }
      }

      // Option: Update price tag dynamically if prices differ per size
      const priceTag = form.closest('.product-details-wrapper, .product-section-inner')?.querySelector('.product-price-tag');
      const priceStr = selectedOption.getAttribute('data-price-formatted');
      if (priceTag && priceStr) {
        priceTag.textContent = priceStr;
      }
    });
  });
}

/* AJAX Cart additions */
function initAjaxCart() {
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.product-ajax-form');
    if (!form) return;

    e.preventDefault();

    const submitBtn = form.querySelector('.add-to-cart-submit-btn');
    const originalText = submitBtn.textContent;
    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.textContent = 'ADDING...';

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
      return response.json();
    })
    .then(data => {
      trackPixelEvent('AddToCart', {
        content_name: data.product_title,
        content_type: 'product',
        content_ids: [String(data.id)],
        contents: [{ id: String(data.id), quantity: data.quantity }],
        // /cart/add.js returns money in cents.
        value: (data.final_line_price || data.line_price || 0) / 100,
        currency: (window.themeSettings || {}).currency
      });

      // Success adding - refresh cart drawer using Section Rendering API
      refreshCartDrawer(true);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('Could not add item to cart. Please try again.');
    })
    .finally(() => {
      submitBtn.removeAttribute('disabled');
      submitBtn.textContent = originalText;
    });
  });
}

/* Refresh the cart drawer dynamically */
function refreshCartDrawer(openDrawerAfter = false) {
  fetch('/?sections=cart-drawer')
    .then(response => response.json())
    .then(sections => {
      const htmlString = sections['cart-drawer'];
      if (!htmlString) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      
      const newDrawerContent = doc.getElementById('CartDrawerContent');
      const currentDrawerContent = document.getElementById('CartDrawerContent');
      if (newDrawerContent && currentDrawerContent) {
        currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
      }

      // Update cart count badge
      const headerCartCount = document.querySelector('.site-header .cart-count');
      
      let totalCount = 0;
      doc.querySelectorAll('.qty-adjust-input').forEach(input => {
        totalCount += parseInt(input.value) || 0;
      });

      if (headerCartCount) {
        headerCartCount.textContent = totalCount;
      }

      bindDrawerInteractiveEvents();

      if (openDrawerAfter) {
        openCartDrawer();
      }
    })
    .catch(error => {
      console.error('Error updating cart drawer:', error);
    });
}

/* Open/Close drawer functions */
function openCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

/* Cart Drawer Bindings */
function initCartDrawerEvents() {
  document.addEventListener('click', function(e) {
    if (e.target.id === 'CartToggle') {
      e.preventDefault();
      openCartDrawer();
    }
    if (e.target.id === 'CartDrawerClose' || e.target.id === 'CartDrawerBackdrop') {
      closeCartDrawer();
    }
  });

  bindDrawerInteractiveEvents();
}

/* Bind item additions/subtractions in drawer */
function bindDrawerInteractiveEvents() {
  const drawerContent = document.getElementById('CartDrawerContent');
  if (!drawerContent) return;

  drawerContent.querySelectorAll('.qty-adjust-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.parentNode.querySelector('.qty-adjust-input');
      const lineIndex = input.getAttribute('data-line-item-index');
      const delta = parseInt(this.getAttribute('data-qty-delta'));
      const currentVal = parseInt(input.value) || 0;
      
      const newVal = Math.max(0, currentVal + delta);
      input.value = newVal;

      updateLineItemQuantity(lineIndex, newVal);
    });
  });

  drawerContent.querySelectorAll('.qty-adjust-input').forEach(input => {
    input.addEventListener('change', function() {
      const lineIndex = this.getAttribute('data-line-item-index');
      const newVal = Math.max(0, parseInt(this.value) || 0);
      updateLineItemQuantity(lineIndex, newVal);
    });
  });

  drawerContent.querySelectorAll('.cart-drawer-item-remove-link').forEach(link => {
    link.addEventListener('click', function() {
      const lineIndex = this.getAttribute('data-remove-line-index');
      updateLineItemQuantity(lineIndex, 0);
    });
  });
}

function updateLineItemQuantity(lineIndex, quantity) {
  const drawerContent = document.getElementById('CartDrawerContent');
  if (drawerContent) {
    drawerContent.style.opacity = '0.5';
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: lineIndex,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    refreshCartDrawer(false);
  })
  .catch(error => {
    console.error('Error updating cart quantity:', error);
  })
  .finally(() => {
    if (drawerContent) {
      drawerContent.style.opacity = '1';
    }
  });
}

/* Accordions for Product detail disclosures */
function initAccordions() {
  document.addEventListener('click', function(e) {
    const toggle = e.target.closest('.desc-accordion-toggle');
    if (!toggle) return;

    const accordion = toggle.closest('.product-desc-accordion');
    const content = accordion.querySelector('.desc-accordion-content');

    if (accordion.classList.contains('active')) {
      accordion.classList.remove('active');
      content.style.maxHeight = '0px';
    } else {
      const productBlock = accordion.closest('.product-details-wrapper');
      if (productBlock) {
        productBlock.querySelectorAll('.product-desc-accordion.active').forEach(activeAcc => {
          activeAcc.classList.remove('active');
          activeAcc.querySelector('.desc-accordion-content').style.maxHeight = '0px';
        });
      }

      accordion.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
}

/* Size Chart Unit Toggle Listener */
document.addEventListener('click', function(e) {
  const toggleBtn = e.target.closest('.unit-toggle-btn');
  if (!toggleBtn) return;
  
  const container = toggleBtn.closest('.product-desc-accordion');
  if (!container) return;
  
  container.querySelectorAll('.unit-toggle-btn').forEach(btn => btn.classList.remove('active'));
  toggleBtn.classList.add('active');
  
  const unit = toggleBtn.getAttribute('data-unit');
  const cmTable = container.querySelector('.size-chart-table.unit-cm');
  const inchTable = container.querySelector('.size-chart-table.unit-inch');
  const content = container.querySelector('.desc-accordion-content');
  
  if (unit === 'cm') {
    if (cmTable) cmTable.style.display = 'table';
    if (inchTable) inchTable.style.display = 'none';
  } else {
    if (cmTable) cmTable.style.display = 'none';
    if (inchTable) inchTable.style.display = 'table';
  }
  
  // Update accordion height to prevent clipping
  if (content && container.classList.contains('active')) {
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});

/* Interactive Click Sound Effects (Web Audio API Synthesizer) */
function initSoundEffects() {
  const settings = window.themeSettings || { enableSoundEffects: true, soundEffectsVolume: 50 };
  if (!settings.enableSoundEffects) return;

  let audioCtx = null;
  const volumeScale = (settings.soundEffectsVolume || 50) / 100;

  function getAudioContext() {
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') {
      audioCtx.resume();
    }
    return audioCtx;
  }

  function playClickSound(type = 'default') {
    try {
      const ctx = getAudioContext();
      if (!ctx) return;

      const now = ctx.currentTime;

      if (type === 'special') {
        // Satisfying chime / success sound: quick double-tap (high-pitch sliding up)
        const playBeep = (timeOffset, pitch, dur) => {
          const osc = ctx.createOscillator();
          const gainNode = ctx.createGain();

          osc.type = 'sine';
          osc.frequency.setValueAtTime(pitch, now + timeOffset);
          osc.frequency.exponentialRampToValueAtTime(pitch * 1.5, now + timeOffset + dur);

          gainNode.gain.setValueAtTime(0.001, now + timeOffset);
          gainNode.gain.linearRampToValueAtTime(0.08 * volumeScale, now + timeOffset + 0.01);
          gainNode.gain.exponentialRampToValueAtTime(0.001, now + timeOffset + dur);

          osc.connect(gainNode);
          gainNode.connect(ctx.destination);

          osc.start(now + timeOffset);
          osc.stop(now + timeOffset + dur);
        };

        playBeep(0, 600, 0.08);
        playBeep(0.07, 900, 0.12);
      } else {
        // Chess Click: A sharp woody transient and lower resonant body
        const bodyOsc = ctx.createOscillator();
        const bodyGain = ctx.createGain();
        bodyOsc.type = 'triangle';
        bodyOsc.frequency.setValueAtTime(380, now);
        bodyOsc.frequency.exponentialRampToValueAtTime(140, now + 0.04);

        bodyGain.gain.setValueAtTime(0.001, now);
        bodyGain.gain.linearRampToValueAtTime(0.25 * volumeScale, now + 0.003);
        bodyGain.gain.exponentialRampToValueAtTime(0.001, now + 0.04);

        bodyOsc.connect(bodyGain);
        bodyGain.connect(ctx.destination);
        bodyOsc.start(now);
        bodyOsc.stop(now + 0.04);

        const transientOsc = ctx.createOscillator();
        const transientGain = ctx.createGain();
        transientOsc.type = 'sine';
        transientOsc.frequency.setValueAtTime(1200, now);
        transientOsc.frequency.exponentialRampToValueAtTime(800, now + 0.006);

        transientGain.gain.setValueAtTime(0.001, now);
        transientGain.gain.linearRampToValueAtTime(0.08 * volumeScale, now + 0.001);
        transientGain.gain.exponentialRampToValueAtTime(0.001, now + 0.006);

        transientOsc.connect(transientGain);
        transientGain.connect(ctx.destination);
        transientOsc.start(now);
        transientOsc.stop(now + 0.006);
      }
    } catch (e) {
      console.warn('Web Audio playback error:', e);
    }
  }

  // Bind click listeners globally using event delegation
  document.addEventListener('click', function(e) {
    const target = e.target.closest('a, button, input[type="submit"], input[type="button"], .qty-adjust-btn, .desc-accordion-toggle, .unit-toggle-btn, .PI__select, .ProductGridItem');
    if (!target) return;

    // Check for special buttons (cart actions, qty, etc.)
    const isSpecial = target.classList.contains('add-to-cart-submit-btn') || 
                      target.closest('.cart-drawer-checkout-btn') || 
                      target.closest('.qty-adjust-btn') ||
                      target.closest('.cart-drawer-item-remove-link');

    playClickSound(isSpecial ? 'special' : 'default');
  }, { passive: true });
}

/* Block right-click save / drag-off on imagery */
function initImageProtection() {
  document.addEventListener('contextmenu', function(e) {
    if (e.target.closest('img, picture, svg, .product-media, [style*="background-image"]')) {
      e.preventDefault();
    }
  });

  document.addEventListener('dragstart', function(e) {
    if (e.target.closest('img, picture, svg')) {
      e.preventDefault();
    }
  });
}



/* Product media carousel: touch-scroll first, with tap controls and progress state. */
function initProductMediaCarousels() {
  document.querySelectorAll('[data-product-media-carousel]').forEach(function(carousel) {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';

    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const status = carousel.querySelector('[data-carousel-status]');
    const indicators = Array.from(carousel.querySelectorAll('[data-carousel-indicator]'));

    if (!viewport || slides.length < 2) return;

    let activeIndex = 0;
    let ticking = false;

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      if (status) status.textContent = (activeIndex + 1) + ' / ' + slides.length;
      indicators.forEach(function(indicator, indicatorIndex) {
        const isActive = indicatorIndex === activeIndex;
        indicator.classList.toggle('is-active', isActive);
        if (isActive) {
          indicator.setAttribute('aria-current', 'true');
        } else {
          indicator.removeAttribute('aria-current');
        }
      });
    }

    function moveTo(index) {
      setActive(index);
      slides[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    if (previous) {
      previous.addEventListener('click', function() {
        moveTo(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function() {
        moveTo(activeIndex + 1);
      });
    }

    indicators.forEach(function(indicator) {
      indicator.addEventListener('click', function() {
        moveTo(Number(indicator.dataset.carouselIndicator));
      });
    });

    viewport.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        const width = viewport.clientWidth || 1;
        setActive(Math.round(viewport.scrollLeft / width));
        ticking = false;
      });
    }, { passive: true });

    setActive(0);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductMediaCarousels);
} else {
  initProductMediaCarousels();
}
document.addEventListener('shopify:section:load', initProductMediaCarousels);


/* One-click size selection to add the second Chud Light Hoodie from the cart. */
function initHoodieQuickAdd() {
  if (document.documentElement.dataset.hoodieQuickAddReady === 'true') return;
  document.documentElement.dataset.hoodieQuickAddReady = 'true';

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-hoodie-quick-add-variant]');
    if (!button || button.disabled || button.dataset.adding === 'true') return;

    event.preventDefault();

    const variantId = Number(button.dataset.hoodieQuickAddVariant);
    if (!variantId) return;

    const buttons = Array.from(document.querySelectorAll('[data-hoodie-quick-add-variant]'));
    buttons.forEach(function(sizeButton) {
      sizeButton.disabled = true;
    });

    button.dataset.adding = 'true';
    const originalText = button.textContent;
    button.textContent = 'ADDING';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Could not add hoodie to cart');
        return response.json();
      })
      .then(function(item) {
        trackPixelEvent('AddToCart', {
          content_name: item.product_title,
          content_type: 'product',
          content_ids: [String(item.id)],
          contents: [{ id: String(item.id), quantity: 1 }],
          value: (item.final_line_price || item.price || 0) / 100,
          currency: (window.themeSettings || {}).currency
        });

        if (window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }

        refreshCartDrawer(true);
      })
      .catch(function(error) {
        console.error('Error adding the second hoodie:', error);
        button.textContent = 'TRY AGAIN';
        buttons.forEach(function(sizeButton) {
          sizeButton.disabled = false;
        });
      })
      .finally(function() {
        delete button.dataset.adding;
        if (window.location.pathname !== '/cart') {
          window.setTimeout(function() {
            if (button.isConnected) button.textContent = originalText;
          }, 250);
        }
      });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHoodieQuickAdd);
} else {
  initHoodieQuickAdd();
}
